var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TipsPage"},[_c('img',{staticClass:"img",attrs:{"src":"https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/icon_info.png"}}),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.infoText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }